import { Component } from 'react';
import { connect } from 'react-redux';
import { fetchNews } from '../../redux/news/actions';
import { newsSelector } from '../../redux/news/selectors';
import FlashingList from '../FlashingList';

interface IMapStateProps {
  news: any[]
}

interface IMapDispatchProps {
  getNews: (token: string) => void
}

class News extends Component<IMapStateProps & IMapDispatchProps, {}> {
  public componentDidMount() {
    const token = localStorage.getItem('token');
    this.props.getNews(token || '');
  }

  public render() {
    if (this.props.news && this.props.news.length > 0) {
      return <FlashingList messages={this.props.news} />;
    }
    return <div />
  }
}

const mapStateToProps = (state: any) => ({
  news: newsSelector(state)
});

const mapDispatchToProps = {
  getNews: (token: string) => fetchNews(token)
};

export default connect<IMapStateProps, IMapDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps
)(News);
